// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fb-panel { padding: 0 0 40px; overflow-y: auto; }

.fb-section { margin: 0 16px 20px; }
.fb-section-title {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--text-muted);
  padding: 8px 0 6px;
  border-bottom: 1px solid var(--border);
  margin-bottom: 8px;
}

.fb-item {
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: 4px;
  padding: 10px 12px;
  margin-bottom: 8px;
}
.fb-item.fb-done { opacity: 0.55; }

.fb-item-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
  flex-wrap: wrap;
}
.fb-type-badge {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 7px;
  border-radius: 3px;
  flex-shrink: 0;
}
.fb-type-bug      { background: rgba(228,85,85,0.15);  color: #e45555; }
.fb-type-feedback { background: rgba(86,182,194,0.15); color: #56b6c2; }

.fb-user  { font-size: 12px; font-weight: 500; color: var(--text-primary); }
.fb-role  { font-size: 11px; color: var(--text-muted); }
.fb-date  { font-size: 11px; color: var(--text-muted); margin-left: auto; }
.fb-actions { display: flex; gap: 2px; flex-shrink: 0; }

.fb-message {
  font-size: 13px;
  color: var(--text-secondary);
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
}
`, "",{"version":3,"sources":["webpack://./src/components/feedback/FeedbackPanel.css"],"names":[],"mappings":"AAAA,YAAY,iBAAiB,EAAE,gBAAgB,EAAE;;AAEjD,cAAc,mBAAmB,EAAE;AACnC;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;EAClB,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;AACA,mBAAmB,aAAa,EAAE;;AAElC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;AACA,oBAAoB,gCAAgC,GAAG,cAAc,EAAE;AACvE,oBAAoB,iCAAiC,EAAE,cAAc,EAAE;;AAEvE,YAAY,eAAe,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;AAC3E,YAAY,eAAe,EAAE,wBAAwB,EAAE;AACvD,YAAY,eAAe,EAAE,wBAAwB,EAAE,iBAAiB,EAAE;AAC1E,cAAc,aAAa,EAAE,QAAQ,EAAE,cAAc,EAAE;;AAEvD;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB","sourcesContent":[".fb-panel { padding: 0 0 40px; overflow-y: auto; }\n\n.fb-section { margin: 0 16px 20px; }\n.fb-section-title {\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: var(--text-muted);\n  padding: 8px 0 6px;\n  border-bottom: 1px solid var(--border);\n  margin-bottom: 8px;\n}\n\n.fb-item {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: 4px;\n  padding: 10px 12px;\n  margin-bottom: 8px;\n}\n.fb-item.fb-done { opacity: 0.55; }\n\n.fb-item-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 6px;\n  flex-wrap: wrap;\n}\n.fb-type-badge {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  padding: 2px 7px;\n  border-radius: 3px;\n  flex-shrink: 0;\n}\n.fb-type-bug      { background: rgba(228,85,85,0.15);  color: #e45555; }\n.fb-type-feedback { background: rgba(86,182,194,0.15); color: #56b6c2; }\n\n.fb-user  { font-size: 12px; font-weight: 500; color: var(--text-primary); }\n.fb-role  { font-size: 11px; color: var(--text-muted); }\n.fb-date  { font-size: 11px; color: var(--text-muted); margin-left: auto; }\n.fb-actions { display: flex; gap: 2px; flex-shrink: 0; }\n\n.fb-message {\n  font-size: 13px;\n  color: var(--text-secondary);\n  line-height: 1.5;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
